import { render, staticRenderFns } from "./changepsw.vue?vue&type=template&id=c561192c&scoped=true"
import script from "./changepsw.vue?vue&type=script&lang=js"
export * from "./changepsw.vue?vue&type=script&lang=js"
import style0 from "./changepsw.vue?vue&type=style&index=0&id=c561192c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561192c",
  null
  
)

export default component.exports